import { Mappeable } from './mappeable.model';

export class JobPai extends Mappeable {
    jobId: number;
    paiId: number;

}